import axios from '../../../../shared/axios/new-api-axios';

import * as actionTypes from '../constants/actionTypes';

import { validateObj } from '../../../../shared/utils';

const getSignatureBytesStart = () => {
  return {
    type: actionTypes.SIGNATURE_GET_SIGNATURE_BYTES_START,
  };
};

const getSignatureBytesSuccess = (data) => {
  return {
    type: actionTypes.SIGNATURE_GET_SIGNATURE_BYTES_SUCCESS,
    data,
  };
};

const getSignatureBytesFail = (error) => {
  return {
    type: actionTypes.SIGNATURE_GET_SIGNATURE_BYTES_FAIL,
    error,
  };
};

export const getSignatureBytes = (signatureId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getSignatureBytesStart());

      const url = `/signature/get-signature-bytes`;

      axios
        .get(url, { responseType: 'blob', params: validateObj({ signatureId }) })
        .then((response) => {
          new Response(response.data).arrayBuffer().then((result) => {
            dispatch(getSignatureBytesSuccess(result));
            resolve(result);
          });
        })
        .catch((err) => {
          dispatch(getSignatureBytesFail(err));
          reject(err);
        });
    });
  };
};
